import { createBrowserHistory } from 'history';

console.log(new Error().stack, 'ACA!!!');
const appHistory = createBrowserHistory();

export default appHistory;
